module.exports = __webpack_public_path__ + "img/14.28b9b829.jpg";